import { Prismic, PrismicText } from '@landsbankinn/prismic';
import { AccordionItem, AccordionList } from '@landsbankinn/ui';
import Head from 'next/head';
import React from 'react';

interface IProps {
  heading: Prismic.RichText;
  single_display?: boolean;
  fields: IField[];
}

interface IField {
  item: IItem;
  faqItem: IItem;
  category?: IFaqCategory;
}

interface IItem {
  question: Prismic.RichText;
  answer: Prismic.RichText;
}

interface IFaqCategory {
  title: Prismic.RichText;
}

function renderSchemaOrgQuestion({ item, faqItem }: IField) {
  const theItem = item || faqItem;
  return {
    '@type': 'Question',
    name: Prismic.text(theItem?.question),
    acceptedAnswer: {
      '@type': 'Answer',
      text: Prismic.text(theItem?.answer),
    },
  };
}

export const FaqContainer = ({ heading, single_display, fields }: IProps) => {
  const items = fields?.filter(({ item, faqItem }) => item || faqItem);
  if (!items.length) {
    return null;
  }

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: items.map(renderSchemaOrgQuestion),
            }),
          }}
        />
      </Head>
      <AccordionList
        title={Prismic.text(heading)}
        singleDisplay={single_display}
      >
        {items.map(({ item, faqItem, category }, index) => {
          const theItem = item || faqItem;
          return (
            <AccordionItem
              key={`${index}-${Prismic.text(theItem?.question)}`}
              title={Prismic.text(theItem?.question) ?? undefined}
              content={<PrismicText value={theItem?.answer} />}
              category={<PrismicText value={category?.title} />}
            />
          );
        })}
      </AccordionList>
    </>
  );
};
